import Vue from 'vue';
import './plugins/axios';
import Buefy from 'buefy';
import App from './App.vue';
import router from './router';
import store from './store';
import './assets/scss/app.scss';

Vue.use(Buefy);

Vue.config.productionTip = false;

Vue.filter('formatCurrency', (value) => {
  const val = (value / 1).toFixed(2).replace('.', ',');
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
});
Vue.filter('padzero', value => (value < 10 ? '0' : '') + value);

Vue.prototype.$filters = Vue.options.filters;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
